module.exports = __webpack_public_path__ + "IconoEncuesta.png";